module.exports = __webpack_public_path__ + "media/images/background-6b0e1c8954ffabeb6ac5b7e335237c90.webp";